module.exports = "<div [ngClass]=\"buttonClass\" class=\"flex row clickable compact block-button\">\n  <span class=\"icon\" [ngClass]=\"leadingIcon\" (click)=\"leadingClicked.next($event)\" *ngIf=\"leadingIcon\"></span>\n  <span class=\"grow text\" [ngClass]=\"textClass\"><ng-content></ng-content></span>\n  <span class=\"badge\" [ngClass]=\"badgeClass\" *ngIf=\"badgeClass\"></span>\n  <span class=\"icon trailing silver\" [ngClass]=\"trailingIcon\" (click)=\"trailingClicked.next($event)\" *ngIf=\"trailingIcon\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/block-button/block-button.component.html
// module id = 1527
// module chunks = 2